export default "__VITE_ASSET__DHhaa9uW__"